export default __webpack_public_path__ + "static/media/AddToListHeader.743a7636.svg";